(function ($) {
  var elementorHookRegistered = false;
  var instanceCount = 0;

  function getListingFormationsWrappers($scope) {
    if ($scope.is('.listing-formations-container')) {
      return $scope;
    }

    return $scope.find('.listing-formations-container');
  }

  function initListingFormations($scope) {
    getListingFormationsWrappers($scope).each(function () {
      var $listing = $(this);

      if ($listing.data('listingFormationsInitialized')) {
        return;
      }

      $listing.data('listingFormationsInitialized', true);

      var durationMin = '';
      var durationMax = '';
      var currentPage = 1;
      var isLoading = false;
      var hasMore = true;
      var postsPerPage = 12;
      var scrollEvent = '.listingFormations' + (++instanceCount);
      var $itemsContainer = $listing.find('.items-container').first();

      function setLoading(loading) {
        isLoading = loading;
        $listing.toggleClass('is-filtering', loading).attr('aria-busy', loading ? 'true' : 'false');
        $listing.find('aside, .container-filters').prop('inert', loading);
        $listing.find('.count').toggleClass('is-loading', loading);

        if (slider && slider.noUiSlider) {
          slider.noUiSlider[loading ? 'disable' : 'enable']();
        }
      }

      function getFormationsContainer() {
        if (!$itemsContainer.length) {
          return $();
        }

        var $formations = $itemsContainer.children('.formations').first();

        if (!$formations.length) {
          $formations = $('<div class="formations"></div>');
          $itemsContainer.empty().append($formations);
        }

        return $formations;
      }

      function getListingHtmlItems(html) {
        var parsedHtml = $.parseHTML($.trim(html || ''), document, true);
        var $wrapper = $('<div></div>').append(parsedHtml);
        var $formations = $wrapper.children('.formations').first();

        return $formations.length ? $formations.children() : $wrapper.contents();
      }

      function getForcedFormationLevels() {
        try {
          return JSON.parse($itemsContainer.attr('data-forced-formation-level') || '[]').map(Number);
        } catch (error) {
          return [];
        }
      }

      function getForcedTaxonomies() {
        var forcedLevels = getForcedFormationLevels();
        var forced = forcedLevels.length ? {formation_level: forcedLevels} : {};

        if ($itemsContainer.attr('data-entreprise') === 'yes') {
          forced.product_cat_slug = ['entreprise'];
        }

        return forced;
      }

      function updateTermCounts(termCounts) {
        if (!termCounts) {
          return;
        }

        $listing.find('input[type="checkbox"]').each(function () {
          var $input = $(this);
          var parent = $input.data('parent');
          var value = $input.val();
          var count = 0;

          if (parent === 'demarrage') {
            count = termCounts.demarrage && termCounts.demarrage[value]
              ? parseInt(termCounts.demarrage[value], 10)
              : 0;
          } else {
            count = termCounts[parent] && termCounts[parent][value]
              ? parseInt(termCounts[parent][value], 10)
              : 0;
          }

          var $term = $input.closest('.term');

          $term.find('.count').text(count);
          $term.toggle(count !== 0 || $input.is(':checked'));
        });
      }

      function getSelectedTaxonomies() {
        var selectedTaxonomies = {};
        var demarrage = [];

        $listing.find('input[type="checkbox"]:checked').each(function () {
          var $input = $(this);
          var parent = $input.data('parent');

          if (parent === 'demarrage') {
            demarrage.push($input.val());
            return;
          }

          if (!selectedTaxonomies[parent]) {
            selectedTaxonomies[parent] = [];
          }

          selectedTaxonomies[parent].push($input.val());
        });

        return {
          selectedTaxonomies: selectedTaxonomies,
          demarrage: demarrage
        };
      }

      function hasDurationFilter() {
        return (
          durationMin !== '' &&
          durationMax !== '' &&
          !(parseInt(durationMin, 10) === 0 && parseInt(durationMax, 10) === 5000)
        );
      }

      function updateFeaturedVisibility() {
        var isFeatured = $listing.find('.filters-featured:checked').length ? 1 : '';
        var hasActiveFilters =
          $listing.find('input[type="checkbox"]:checked').length > 0 ||
          isFeatured ||
          hasDurationFilter();

        $listing.find('.featured-formations').toggle(!hasActiveFilters);
      }

      function buildProductsRequestData() {
        var filters = getSelectedTaxonomies();
        var isFeatured = $listing.find('.filters-featured:checked').length ? 1 : '';
        var requestData = {
          type: 'product',
          forced_taxonomy: getForcedTaxonomies(),
          taxonomy: filters.selectedTaxonomies,
          featured: isFeatured,
          numberpost: postsPerPage,
          currentpage: currentPage
        };

        if (filters.demarrage.length) {
          requestData.demarrage = filters.demarrage;
        }

        if (hasDurationFilter()) {
          requestData.duree_min = parseInt(durationMin, 10);
          requestData.duree_max = parseInt(durationMax, 10);
        }

        return requestData;
      }

      function fetchProducts(reset) {
        reset = reset === true;

        if (isLoading || (!hasMore && !reset)) {
          return;
        }

        if (reset) {
          currentPage = 1;
          hasMore = true;
        } else {
          currentPage++;
        }

        updateFeaturedVisibility();
        setLoading(true);

        $.ajax({
          url: '/wp-json/penega/v1/posts',
          method: 'GET',
          data: buildProductsRequestData(),
          success: function (res) {
            var $formations = getFormationsContainer();

            if ($formations.length && res.html) {
              var $items = getListingHtmlItems(res.html)
                .not('.no-results, .aucun-resultat, .empty-results')
                .filter(function () {
                  return !$(this).text().toLowerCase().includes('aucun résultat');
                });

              if ($items.length) {
                if (reset) {
                  $formations.empty().append($items);
                } else {
                  $formations.append($items);
                }
              }

              if (reset && !$items.length) {
                $formations.html('<p class="no-results">Aucun résultat trouvé</p>');
              }

              $(document).trigger('penega:formations-updated');
            }

            updateTermCounts(res.term_counts);
            hasMore = currentPage * postsPerPage < parseInt(res.result_count || 0, 10);
          },
          error: function (xhr) {
            console.log(xhr.responseText);
          },
          complete: function () {
            setLoading(false);
          }
        });
      }

      function handleCampusVisibility() {
        var isOnlineSelected = $listing.find('input[data-parent="formation_types"]:checked').filter(function () {
          return $(this).attr('rel') === 'formation-en-ligne';
        }).length > 0;

        $listing.find('#campus').stop(true, true)[isOnlineSelected ? 'slideUp' : 'slideDown']();
      }

      function resetProductsListing() {
        handleCampusVisibility();
        fetchProducts(true);
      }

      $(window).on('scroll' + scrollEvent, function () {
        if (!hasMore || isLoading || !$itemsContainer.length) {
          return;
        }

        var scrollBottom = $(window).scrollTop() + $(window).height();
        var triggerPoint = $itemsContainer.offset().top + $itemsContainer.outerHeight() - 300;

        if (scrollBottom >= triggerPoint) {
          fetchProducts(false);
        }
      });

      $listing.find('.container-terms').each(function () {
        var $container = $(this);

        $container.find('label.term[data-show-all]').on('click.listingFormations', function (event) {
          event.preventDefault();
          if (isLoading) return;

          $container.find('input[type="checkbox"]').prop('checked', false);
          $container.find('label.term').removeClass('active');
          resetProductsListing();
        });

        $container.find('label.term:not([data-show-all])').on('click.listingFormations', function (event) {
          event.preventDefault();
          if (isLoading) return;

          var $label = $(this);
          var $checkbox = $label.find('input[type="checkbox"]');
          var checked = !$checkbox.prop('checked');

          $container.find('label.term[data-show-all]').removeClass('active');
          $checkbox.prop('checked', checked);
          $label.toggleClass('active', checked);
          resetProductsListing();
        });
      });

      $listing.find('.container-filters').each(function () {
        var $container = $(this);

        $container.find('label.filter[data-show-all]').on('click.listingFormations', function (event) {
          event.preventDefault();
          if (isLoading) return;

          $container.find('input[type="radio"]').prop('checked', false);
          $container.find('label.filter').removeClass('active');
          resetProductsListing();
        });

        $container.find('label.filter:not([data-show-all])').on('click.listingFormations', function (event) {
          event.preventDefault();
          if (isLoading) return;

          var $label = $(this);
          var $radio = $label.find('input[type="radio"]');
          var checked = !$radio.prop('checked');

          $container.find('label.filter[data-show-all]').removeClass('active');
          $radio.prop('checked', checked);
          $label.toggleClass('active', checked);
          resetProductsListing();
        });
      });

      var slider = $listing.find('#duration-slider').get(0);
      var sliderMax = $('body').hasClass('page-formations-pour-les-entreprises') ? 150 : 5000;
      var sliderRange = sliderMax === 150
        ? {min: [0, 1], max: [150]}
        : {min: [0, 1], '50%': [1000, 1], max: [5000]};

      function resetDurationSlider() {
        durationMin = '';
        durationMax = '';

        if (slider && slider.noUiSlider) {
          slider.noUiSlider.set([0, sliderMax]);
        }
      }

      if (slider && window.noUiSlider) {
        noUiSlider.create(slider, {
          start: [0, sliderMax],
          connect: true,
          range: sliderRange,
          tooltips: true,
          format: {
            to: function (value) {
              return Math.round(value);
            },
            from: function (value) {
              return Number(value);
            }
          }
        });

        slider.noUiSlider.on('change', function (values) {
          if (isLoading) return;

          durationMin = parseInt(values[0], 10);
          durationMax = parseInt(values[1], 10);
          resetProductsListing();
        });
      }

      $listing.find('.reset-filters').on('click.listingFormations', function (event) {
        event.preventDefault();
        if (isLoading) return;

        $listing.find('input[type="checkbox"], input[type="radio"]').prop('checked', false);
        $listing.find('label.term, label.filter').removeClass('active').show();
        resetDurationSlider();
        resetProductsListing();
      });
    });
  }

  function registerElementorHook() {
    if (
      elementorHookRegistered ||
      !window.elementorFrontend ||
      !window.elementorFrontend.hooks
    ) {
      return;
    }

    elementorHookRegistered = true;
    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/listing-formations.default',
      initListingFormations
    );
  }

  $(window).on('elementor/frontend/init', registerElementorHook);

  $(function () {
    registerElementorHook();
    initListingFormations($(document));
  });
})(jQuery);
